import { render, staticRenderFns } from "./PersonalPage.vue?vue&type=template&id=3c54cf33&scoped=true&class=PersonalPage"
import script from "./PersonalPage.vue?vue&type=script&lang=js"
export * from "./PersonalPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalPage.vue?vue&type=style&index=0&id=3c54cf33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54cf33",
  null
  
)

export default component.exports